import { z } from 'zod';
import { CAMERA_GIMBAL_IDS } from './camera-gimbal.js';
export const CameraGimbalSchema = z.enum(CAMERA_GIMBAL_IDS);
